import styled from 'styled-components';

import { Text } from '@/nova/components';
import { CFG, CFG_MONO_FONT } from '../../../../../../theme/configurator-tokens';
import { FINISH } from '../../finish.tokens';

export const Root = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const SummaryLabel = styled(Text)`
  font-size: 14px;
  line-height: 1;
  color: ${CFG.base400};
`;

/* ----------------------------------- Row ----------------------------------- */

export const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 48px;
  border-radius: 16px;
  padding: 4px 8px;
`;

export const RowLabels = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const RowLabel = styled(Text)`
  font-size: 16px;
  font-weight: 700;
  line-height: 1;
  color: ${FINISH.rowLabel};
`;

export const RowSublabel = styled(Text)<{ $success?: boolean }>`
  font-size: 14px;
  font-weight: 500;
  line-height: 1.2;
  color: ${({ $success }) => ($success ? FINISH.rowSublabelSuccess : FINISH.rowSublabelMuted)};
`;

/** A code-like value shown as a subtitle (the voucher code): a slightly-rounded monospaced pill. */
export const CodePill = styled(Text)`
  align-self: flex-start;
  font-family: ${CFG_MONO_FONT};
  font-size: 13px;
  line-height: 1.5;
  letter-spacing: 0.2px;
  padding: 1px 8px;
  border-radius: 6px;
  background: ${CFG.washHover};
  color: ${FINISH.rowSublabelMuted};
`;

export const RowPrice = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
  white-space: nowrap;
  color: ${CFG.foreground};
`;

export const RowAmount = styled(Text)<{ $success?: boolean }>`
  font-size: 16px;
  font-weight: 700;
  line-height: 1;
  ${({ $success }) => ($success ? `color: ${FINISH.rowSublabelSuccess};` : '')}
`;

export const RowNote = styled(Text)`
  font-size: 14px;
  line-height: 1.1;
  opacity: 0.5;
`;

/* ---------------------------------- Terms ---------------------------------- */

export const Terms = styled.a`
  align-self: flex-end;
  cursor: pointer;
  font-size: 14px;
  color: ${FINISH.termsText};
  text-decoration: underline;
`;

export const TermsLabel = styled(Text)`
  color: inherit;
`;

/* -------------------------------- Footer total ----------------------------- */

export const FooterTotal = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 12px;
`;

export const FooterLabels = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FooterLabel = styled(Text)`
  font-size: 20px;
  font-weight: 700;
  line-height: 1.25;
  color: ${CFG.foreground};
`;

export const FooterSub = styled(Text)`
  font-size: 14px;
  color: ${CFG.base500};
`;

export const FooterAmount = styled(Text)`
  white-space: nowrap;
  font-size: 24px;
  font-weight: 700;
  color: ${CFG.foreground};
`;
